import {
  index as baseIndex
 } from './Base';

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get the complete list of ticket groups
 */
export function fetchTicketGroups() {
  return baseIndex('ticket_groups', 1, 0);
}
